import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import { permissionActions, permissionKeys } from 'src/utils/constants';
import { UserType } from 'src/utils/proptypes';

export const defineAbilityFor = (user: UserType | null) => {
   const { can, build } = new AbilityBuilder(createMongoAbility);

   // For unauthenticated users
   if (!user || !user.roles) {
      return build();
   }

   // For authenticated users
   user.roles.forEach(role => {
      role.permissions?.forEach(permission => {
         if (permission === permissionKeys.PLATFORM_ADMIN) {
            can(permissionActions.MANAGE, 'all');
         } else {
            const action = (permission as string).split('_')[0].toLowerCase()
            const subject = (permission as string).split('_')[1].toLowerCase()

            can(action, subject)
         }
      })
   })

   return build();
};